import { queryDataExt } from "../BaseService/index";
const GlobalConfig = new window.globalConfig();

export const growersByProcessor = async (
  whereClause,
  selectFields,
  sortFields
) => {
  return await queryDataExt(
    `${GlobalConfig.REACT_APP_API_LABUSER_URL}getWithConditions`,
    whereClause,
    selectFields,
    sortFields
  );
};